/* eslint-disable no-param-reassign */
import snakeCase from 'lodash/snakeCase';
import { convertDateToAPIFormat } from './converters/dateConverters';

// default hash serializer
export const hashSerializer = (result, key, value) => {
  const existing = result[key];

  if (existing) {
    if (!Array.isArray(existing)) {
      result[key] = [existing];
    }
    result[key].push(value);
  } else {
    result[key] = value;
  }
  return result;
};

// handle 'boolean' string values as booleans
export const handleBooleans = val => {
  switch (val) {
    case 'true':
      return true;
    case 'false':
      return false;
    default:
      return val;
  }
};

// custom hash serializer itself
export const customSerializer = (result, key, value, formatMessage) => {
  // handle boolean values
  let newValue = handleBooleans(value);

  // handle date format
  if (key === 'dob') {
    newValue = convertDateToAPIFormat(newValue, formatMessage);
  }

  // handle camelCase -> snake_case
  const snakeKey = snakeCase(key);

  return hashSerializer(result, snakeKey, newValue);
};



// WEBPACK FOOTER //
// ./src/utils/customSerializer.js